import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { useSearchAdvertisingDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useSearchAdvertisingDataAndParams";
import { removeProtocolAndWww } from "app/pages/digital-marketing/utils/url";
import { OrganicLandingPagesV2 } from "app/pages/keyword-research/website-analysis/pages/landing-pages/OrganicLandingPagesV2";
import {
    getKeywordsDrilldownTableColumns as getSearchAdvertisingKeywordsDrilldownTableColumns,
    getTableColumns as getSearchAdvertisingTableColumns,
} from "app/pages/keyword-research/website-analysis/pages/landing-pages/SearchAdvertisingLandingPagesColumnConfig";
import { createMultiIncludeExcludeFilter } from "app/pages/website-analysis/traffic-sources/search/components/filters/MultiIncludeExclude/utils";
import { allTrackers } from "app/services/track/track";
import { getDomainWithSubs } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";
import { ROUTES } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingConstants";
import { searchAdvertisingNavigation } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingNavigator";

export const SearchAdvertisingLandingPagesWrapper = () => {
    const routeParams = useSearchAdvertisingDataAndParams();

    const onSeeAllClick =
        (_trackingEventSuffix: string, _state: string, additionalParams = {}) =>
        (url: string) => {
            allTrackers.dispatchTrackEvent("Button", "click", `See all ads`);

            const cleanUrl = removeProtocolAndWww(url);
            const key = getDomainWithSubs(url);
            const navigationParams = {
                ...routeParams,
                ...additionalParams,
                key,
                multiIncludeExcludeUrl: createMultiIncludeExcludeFilter(cleanUrl, "url"),
                selectedPageTab: EAdsTabs[EAdsTabs.Text],
            };
            void searchAdvertisingNavigation.textAndShoppingAds.go(navigationParams);
        };

    return (
        <OrganicLandingPagesV2
            withAddToDashboard={false}
            keywordTargetState={ROUTES.keywords}
            searchAdsTargetState={ROUTES.textAndShoppingAds}
            getColumnsFunction={getSearchAdvertisingTableColumns}
            getKeywordExpansionColumnsFunction={getSearchAdvertisingKeywordsDrilldownTableColumns}
            onSeeAllClick={onSeeAllClick}
        />
    );
};
